// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1kJzm","col":"styles_col__2MKij"};